import React, { useEffect } from "react";
import { googleAnalyticsActions } from "../../utils/ga";
import ProductSectionComponent from "../../components/ProductSectionComponent";
import TopNavComponent from "../../components/TopNavComponent";
import FooterComponent from "../../components/FooterComponent";
import MobileNavComponent from "../../components/MobileNavComponent";
import "./styles.css";

export default function ProductScreen() {
  useEffect(() => {
    googleAnalyticsActions.initGoogleAnalytics();
  }, []);
  return (
    <>
      <MobileNavComponent />
      <div className="product">
        <header class="product-top-nav">
          <TopNavComponent />
        </header>
        <main className="product-main">
          <ProductSectionComponent />
        </main>
        <footer className="product-footer">
          <FooterComponent />
        </footer>
      </div>
    </>
  );
}
